"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gravatar = exports.generateGradient = void 0;
var hsl_rgb_1 = __importDefault(require("hsl-rgb"));
var hsl_triad_1 = __importDefault(require("hsl-triad"));
var string_hash_1 = __importDefault(require("string-hash"));
function uniqueID() {
    return Math.floor(Math.random() * Date.now());
}
function generateGradient(str) {
    var hash = string_hash_1.default(str);
    var colors = hsl_triad_1.default(hash % 360, 1, 0.5);
    var color1 = hsl_rgb_1.default(colors[0][0], colors[0][1], colors[0][2]);
    var color2 = hsl_rgb_1.default(colors[1][0], colors[1][1], colors[1][2]);
    var start = "rgb(" + color1[0] + ", " + color1[1] + ", " + color1[2] + ")";
    var stop = "rgb(" + color2[0] + ", " + color2[1] + ", " + color2[2] + ")";
    return { start: start, stop: stop };
}
exports.generateGradient = generateGradient;
var units = ['px', 'em', 'rem', '%', 'in', 'pt', 'pc', 'cm', 'mm'];
var gravatar = function (str, size) {
    if (size === void 0) { size = '100%'; }
    var _a = generateGradient(str), start = _a.start, stop = _a.stop;
    var id = uniqueID();
    var parsedSize = units.some(function (val) { return ("" + size).includes(val); }) ? size : size + "px";
    return "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg " + (size != undefined ? "width=\"" + parsedSize + "\" height=\"" + parsedSize + "\"" : '') + " version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n  <defs>\n    <linearGradient x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"100%\" id=\"" + id + "\">\n      <stop stop-color=\"" + start + "\" offset=\"0%\"></stop>\n      <stop stop-color=\"" + stop + "\" offset=\"100%\"></stop>\n    </linearGradient>\n  </defs>\n  <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <rect id=\"Rectangle\" fill=\"url(#" + id + ")\" x=\"0\" y=\"0\" width=\"" + parsedSize + "\" height=\"" + parsedSize + "\"></rect>\n  </g>\n</svg>";
};
exports.gravatar = gravatar;
